import React from "react";
import Typography from "material-ui/Typography";
import Table from "material-ui/Table";
import { TableBody } from "material-ui/Table";
import { TableCell } from "material-ui/Table";
import { TableRow } from "material-ui/Table";

import { withStyles } from "material-ui/styles";
import styles from "./styles";
const CopperInt = props => (
  <div>
    <Table className={props.classes.table}>
      <TableBody>
        <TableRow>
          <TableCell className={props.classes.tablecontent_first}>
            {props.translate("test_types_signaltek")}
          </TableCell>
          <TableCell className={props.classes.copper_tablecontent_first}>
            {props.translate(props.data.type)}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={props.classes.tablecontent_first}>
            {props.translate("sub_test_link_status")}
          </TableCell>
          <TableCell className={props.classes.copper_tablecontent_first}>
            {props.data.eth.linkstatus}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={props.classes.tablecontent_first}>
            {props.translate("sub_test_link_speed")}
          </TableCell>
          <TableCell className={props.classes.copper_tablecontent_first}>
            {props.data.eth.linkspeed}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={props.classes.tablecontent_first}>
            {props.translate("result_duplex")}
          </TableCell>
          <TableCell className={props.classes.copper_tablecontent_first}>
            {props.data.eth.linkduplex}
          </TableCell>
        </TableRow>
        {props.blackbirdInterface && <TableRow>
          <TableCell className={props.classes.tablecontent_first}>
            {props.translate("link_ability")}
          </TableCell>
          <TableCell className={props.classes.copper_tablecontent_first}>
            {props.data.eth.linkability}
          </TableCell>
        </TableRow>}
        <TableRow>
          <TableCell className={props.classes.tablecontent_first}>
            {props.translate("subtest_poeload_poestatus")}
          </TableCell>
          <TableCell className={props.classes.copper_tablecontent_first}>
            {props.data.eth.poestatus}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={props.classes.tablecontent_first}>
            {props.translate("result_poe_pow")}
          </TableCell>
          <TableCell className={props.classes.copper_tablecontent_first}>
            {props.data.eth.poepower.toFixed(2)}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={props.classes.tablecontent_first}>
            {props.translate("result_poe_vol")}
          </TableCell>
          <TableCell className={props.classes.copper_tablecontent_first}>
            <table>
              <tr>
                <th className={props.classes.itabVoltageHeader}>
                  {props.translate("result_p1236")}
                </th>
                <th className={props.classes.itabVoltageHeader}>
                  {props.translate("result_p4578")}
                </th>
              </tr>
            </table>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={props.classes.copper_tablecontent_first} />
          <TableCell className={props.classes.copper_tablecontent_first}>
            <table>
              <tr>
                <th className={props.classes.itabVoltageData}>
                  {props.data.eth.pair1236voltage &&
                    props.data.eth.pair1236voltage.toFixed(2)}
                </th>
                <th className={props.classes.itabVoltageData}>
                  {props.data.eth.pair4578voltage &&
                    props.data.eth.pair4578voltage.toFixed(2)}
                </th>
              </tr>
            </table>
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>

    <table style={{ width: "100%" }}>
      <tr
        style={{
          background: "#f2f2f2"
        }}
      >
        <th
          style={{
            border: "1px solid #ddd",
            padding: "15px 35px 15px 35px"
          }}
        ></th>
        <th
          style={{
            border: "1px solid #ddd",
            padding: "15px 35px 15px 35px",
            fontSize: "10pt"
          }}
        >
          {props.translate("result_skew")}
        </th>
        {!props.blackbirdInterface && <th
          style={{
            border: "1px solid #ddd",
            padding: "15px 35px 15px 35px",
            fontSize: "10pt"
          }}
        >
          {props.translate("result_snr")}
        </th>}
      </tr>
      <tr>
        <td
          style={{
            border: "1px solid #ddd",
            padding: "8px",
            textAlign: "center",
            fontSize: "10pt"
          }}
        >
          {props.translate("result_pr1")}
        </td>
        <td
          style={{
            border: "1px solid #ddd",
            padding: "8px",
            textAlign: "center",
            fontSize: "10pt"
          }}
        >
          {props.data.eth.pair12skew}
        </td>
        {!props.blackbirdInterface && <td
          style={{
            border: "1px solid #ddd",
            padding: "8px",
            textAlign: "center",
            fontSize: "10pt"
          }}
        >
          {props.data.eth.pair12snr && props.data.eth.pair12snr.toFixed(1)}
        </td>}
      </tr>
      <tr>
        <td
          style={{
            border: "1px solid #ddd",
            padding: "8px",
            textAlign: "center",
            fontSize: "10pt"
          }}
        >
          {props.translate("result_pr2")}
        </td>
        <td
          style={{
            border: "1px solid #ddd",
            padding: "8px",
            textAlign: "center",
            fontSize: "10pt"
          }}
        >
          {props.data.eth.pair36skew}
        </td>
        {!props.blackbirdInterface && <td
          style={{
            border: "1px solid #ddd",
            padding: "8px",
            textAlign: "center",
            fontSize: "10pt"
          }}
        >
          {props.data.eth.pair36snr && props.data.eth.pair36snr.toFixed(1)}
        </td>}
      </tr>
      <tr>
        <td
          style={{
            border: "1px solid #ddd",
            padding: "8px",
            textAlign: "center",
            fontSize: "10pt"
          }}
        >
          {props.translate("result_pr3")}
        </td>
        <td
          style={{
            border: "1px solid #ddd",
            padding: "8px",
            textAlign: "center",
            fontSize: "10pt"
          }}
        >
          {props.data.eth.pair45skew}
        </td>
        {!props.blackbirdInterface && <td
          style={{
            border: "1px solid #ddd",
            padding: "8px",
            textAlign: "center",
            fontSize: "10pt"
          }}
        >
          {props.data.eth.pair45snr && props.data.eth.pair45snr.toFixed(1)}
        </td>}
      </tr>
      <tr>
        <td
          style={{
            border: "1px solid #ddd",
            padding: "8px",
            textAlign: "center",
            fontSize: "10pt"
          }}
        >
          {props.translate("result_pr4")}
        </td>
        <td
          style={{
            border: "1px solid #ddd",
            padding: "8px",
            textAlign: "center",
            fontSize: "10pt"
          }}
        >
          {props.data.eth.pair78skew}
        </td>
        {!props.blackbirdInterface && <td
          style={{
            border: "1px solid #ddd",
            padding: "8px",
            textAlign: "center",
            fontSize: "10pt"
          }}
        >
          {props.data.eth.pair78snr && props.data.eth.pair78snr.toFixed(1)}
        </td>}
      </tr>
    </table>
  </div>
);
export default withStyles(styles)(CopperInt);



// WEBPACK FOOTER //
// ./src/components/common/results/views/stats/copperInt.js